export class NoInternetConnection extends Error {
    constructor() {
        super("Controleer je internet verbinding en probeer opnieuw.");

        // Set the prototype explicitly.
        Object.setPrototypeOf(this, NoInternetConnection.prototype);
    }
}